import React, { useState } from 'react';
import { ClipboardList, LayoutTemplate, AlertTriangle, BarChart3, Activity } from 'lucide-react';
import { useAppTranslation } from '@/contexts/TranslationContext';
import PlansList from './onboarding/PlansList';
import TemplateLibrary from './onboarding/TemplateLibrary';
import OpenItems from './onboarding/OpenItems';
import PortfolioDashboard from './onboarding/PortfolioDashboard';
import ActivitiesInbox from './onboarding/ActivitiesInbox';
import { config } from '@/src/config';
import { AgentAssistantPanel } from '../../../shared/components/AgentAssistant';

type SubTab = 'plans' | 'activities' | 'templates' | 'open-items' | 'portfolio';

const subTabs: { id: SubTab; label: string; icon: React.ReactNode }[] = [
  { id: 'plans', label: 'Plans', icon: <ClipboardList className="h-4 w-4" /> },
  { id: 'activities', label: 'Activities', icon: <Activity className="h-4 w-4" /> },
  { id: 'templates', label: 'Templates', icon: <LayoutTemplate className="h-4 w-4" /> },
  { id: 'open-items', label: 'Open Items', icon: <AlertTriangle className="h-4 w-4" /> },
  { id: 'portfolio', label: 'Portfolio', icon: <BarChart3 className="h-4 w-4" /> },
];

export default function OnboardingTab() {
  const { t } = useAppTranslation();
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('plans');

  return (
    <div className="space-y-4">
      {config.isTriveny && (
        <AgentAssistantPanel
          agentKey="cs.onboarding"
          title="Onboarding assistant"
          greeting="I can read your onboarding templates and customer plans, and — with your approval — spin up a plan or move a task. What do you need?"
          examples={['Which plans are at risk?', 'Show plans that are behind', 'Start an onboarding plan from a template']}
        />
      )}
      {/* Sub-tab navigation */}
      <div className="flex border-b">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
              activeSubTab === tab.id
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {/* Sub-tab content */}
      {activeSubTab === 'plans' && <PlansList />}
      {activeSubTab === 'activities' && <ActivitiesInbox />}
      {activeSubTab === 'templates' && <TemplateLibrary />}
      {activeSubTab === 'open-items' && <OpenItems />}
      {activeSubTab === 'portfolio' && <PortfolioDashboard />}
    </div>
  );
}
